import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-6 grid grid-cols-12 gap-y-4 gap-4" }
const _hoisted_2 = { class: "flex items-start gap-4" }
const _hoisted_3 = { class: "w-full grid grid-cols-12 gap-4 items-start gap-y-4" }
const _hoisted_4 = { class: "w-fit mt-0" }

import {
  MedKitButton,
  MedKitDateTimeField,
  MedKitFieldValidation,
  MedKitNumberField,
  MedKitSearch,
  MedKitSelect,
  MedKitSwitch,
  MedKitTextField,
} from '@bigpicturemedical/medkit'
import { useWebTemplateHelpers, DvCodedText, DvText, DvBoolean, DvDateTime, DvDuration, TerminologySearch, NodeRepeater, IPath } from '@bigpicturemedical/openehr-vue'
import { PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import enGB from '../locale/en-GB.json'
import { BlockContainer, BlockHeader, BlockPanel, BlockPanelHeader, BlockWell } from './_layout'

// define message schema for Vue component
type MessageSchema = typeof enGB

interface SearchOption {
  label: string
  value: unknown
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyHistoryBlock',
  props: {
  path: {
    type: Object as PropType<IPath>,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  errors: {
    type: Array as PropType<Array<string>>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;



const { getData, getErrors } = useWebTemplateHelpers()

const { t } = useI18n<{message:MessageSchema}>()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BlockContainer), { class: "space-y-6" }, {
    default: _withCtx(({ display }) => [
      _createVNode(_unref(BlockHeader), {
        heading: props.name,
        description: props.description
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DvCodedText), {
            path: props.path.add('exclusion_-_global.global_exclusion_of_family_history')
          }, {
            default: _withCtx(({ value, setValue, items }) => [
              _createVNode(_unref(MedKitSwitch), {
                class: "w-max",
                "model-value": !! value,
                label: _unref(t)('familyHistory.globalExclusionOfFamilyHistory'),
                "label-position": "start",
                contained: "",
                "onUpdate:modelValue": ($event: any) => (setValue($event ? items[0] : undefined))
              }, null, 8, ["model-value", "label", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["path"])
        ]),
        _: 1
      }, 8, ["heading", "description"]),
      (_unref(getErrors)(props.path).length)
        ? (_openBlock(), _createBlock(_unref(MedKitFieldValidation), {
            key: 0,
            id: "family_history_error",
            text: _unref(getErrors)(props.path)[0]
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NodeRepeater), {
        path: props.path.add('family_history.per_family_member'),
        "present-if": ! _unref(getData)(props.path.add('exclusion_-_global.global_exclusion_of_family_history')),
        reverse: ""
      }, {
        header: _withCtx(({ addItem, errors }) => [
          _createVNode(_unref(MedKitButton), {
            class: "w-full",
            label: _unref(t)('familyHistory.perFamilyMember.add'),
            kind: "repeater",
            block: "",
            icon: "plus",
            "icon-position": "start",
            onClick: addItem
          }, null, 8, ["label", "onClick"]),
          (errors[0])
            ? (_openBlock(), _createBlock(_unref(MedKitFieldValidation), {
                key: 0,
                id: "per_family_member_error",
                text: errors[0]
              }, null, 8, ["text"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(({ name: familyMemberNodeName, index: familyMemberIndex, remove: removeFamilyMember, count }) => [
          _createVNode(_unref(BlockPanel), null, {
            default: _withCtx(() => [
              _createVNode(_unref(BlockPanelHeader), { title: familyMemberNodeName }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DvBoolean), {
                    path: props.path.add(`family_history.per_family_member.${familyMemberIndex}.deceased`)
                  }, {
                    default: _withCtx(({ name, value, setValue, errors, validate }) => [
                      _createVNode(_unref(MedKitSwitch), {
                        error: errors[0],
                        label: name,
                        "model-value": value,
                        "label-position": "start",
                        "onUpdate:modelValue": setValue,
                        onInput: validate
                      }, null, 8, ["error", "label", "model-value", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 2
                  }, 1032, ["path"]),
                  (count > 1)
                    ? (_openBlock(), _createBlock(_unref(MedKitButton), {
                        key: 0,
                        label: _unref(t)('familyHistory.perFamilyMember.remove'),
                        size: "small",
                        "icon-position": "only",
                        icon: "delete",
                        onClick: removeFamilyMember
                      }, null, 8, ["label", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(DvCodedText), {
                  path: props.path.add(`family_history.per_family_member.${familyMemberIndex}.relationship`)
                }, {
                  default: _withCtx(({ name, options, selected, setSelected, errors, validate, required }) => [
                    _createVNode(_unref(MedKitSelect), {
                      class: "col-span-12 sm:col-span-6 md:col-span-9",
                      error: errors[0],
                      label: name,
                      "model-value": selected,
                      options: options,
                      required: required,
                      "onUpdate:modelValue": setSelected,
                      onInput: validate
                    }, null, 8, ["error", "label", "model-value", "options", "required", "onUpdate:modelValue", "onInput"])
                  ]),
                  _: 2
                }, 1032, ["path"]),
                _createVNode(_unref(DvCodedText), {
                  path: props.path.add(`family_history.per_family_member.${familyMemberIndex}.biological_sex`)
                }, {
                  default: _withCtx(({ name, options, selected, setSelected, errors, validate, required }) => [
                    _createVNode(_unref(MedKitSelect), {
                      class: "col-span-12 sm:col-span-6 md:col-span-3",
                      error: errors[0],
                      label: name,
                      "model-value": selected,
                      options: options,
                      required: required,
                      "onUpdate:modelValue": setSelected,
                      onInput: validate
                    }, null, 8, ["error", "label", "model-value", "options", "required", "onUpdate:modelValue", "onInput"])
                  ]),
                  _: 2
                }, 1032, ["path"]),
                _createVNode(_unref(DvText), {
                  path: props.path.add(`family_history.per_family_member.${familyMemberIndex}.family_member_name`)
                }, {
                  default: _withCtx(({ name, value, setValue, errors, validate, validateIfAlreadyValidated, required }) => [
                    _createVNode(_unref(MedKitTextField), {
                      class: _normalizeClass(["col-span-12", _unref(getData)(props.path.add(`family_history.per_family_member.${familyMemberIndex}.deceased`)) === true ? 'md:col-span-6' : 'sm:col-span-6 md:col-span-9']),
                      error: errors[0],
                      label: name,
                      "model-value": value,
                      required: required,
                      "onUpdate:modelValue": setValue,
                      onInput: validateIfAlreadyValidated,
                      onBlur: validate
                    }, null, 8, ["class", "error", "label", "model-value", "required", "onUpdate:modelValue", "onInput", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["path"]),
                _createVNode(_unref(DvDateTime), {
                  path: props.path.add(`family_history.per_family_member.${familyMemberIndex}.date_of_birth`)
                }, {
                  default: _withCtx(({ name, value, setValue, errors, validate, required }) => [
                    _createVNode(_unref(MedKitDateTimeField), {
                      "date-input-only": "",
                      class: "col-span-12 sm:col-span-6 md:col-span-3",
                      error: errors[0],
                      label: name,
                      "model-value": value,
                      required: required,
                      "onUpdate:modelValue": setValue,
                      onInput: validate
                    }, null, 8, ["error", "label", "model-value", "required", "onUpdate:modelValue", "onInput"])
                  ]),
                  _: 2
                }, 1032, ["path"]),
                _createVNode(_unref(DvDateTime), {
                  "present-if": _unref(getData)(props.path.add(`family_history.per_family_member.${familyMemberIndex}.deceased`)) === true,
                  path: props.path.add(`family_history.per_family_member.${familyMemberIndex}.date_of_death`)
                }, {
                  default: _withCtx(({ name, value, setValue, errors, validate, required }) => [
                    _createVNode(_unref(MedKitDateTimeField), {
                      "date-input-only": "",
                      class: "col-span-12 sm:col-span-6 md:col-span-3",
                      error: errors[0],
                      label: name,
                      "model-value": value,
                      required: required,
                      "onUpdate:modelValue": setValue,
                      onInput: validate
                    }, null, 8, ["error", "label", "model-value", "required", "onUpdate:modelValue", "onInput"])
                  ]),
                  _: 2
                }, 1032, ["present-if", "path"])
              ]),
              _createVNode(_unref(BlockWell), { class: "py-6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NodeRepeater), {
                    path: props.path.add(`family_history.per_family_member.${familyMemberIndex}.clinical_history`),
                    reverse: ""
                  }, {
                    header: _withCtx(({ errors, addItem }) => [
                      (errors[0])
                        ? (_openBlock(), _createBlock(_unref(MedKitFieldValidation), {
                            key: 0,
                            id: "per_family_member_error"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(errors[0]), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(MedKitButton), {
                        icon: "plus",
                        kind: "repeater",
                        size: "medium",
                        class: "w-full mb-6",
                        "icon-position": "start",
                        label: _unref(t)('familyHistory.clinicalHistory.add'),
                        onClick: addItem
                      }, null, 8, ["label", "onClick"])
                    ]),
                    default: _withCtx(({ index: clinicalHistoryIndex, visualIndex: clinicalHistoryVisualIndex, remove: removeProblemDiagnosis, count }) => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_unref(DvCodedText), {
                            path: props.path.add(`family_history.per_family_member.${familyMemberIndex}.clinical_history.${clinicalHistoryIndex}.problem_diagnosis_name`)
                          }, {
                            default: _withCtx(({ name, terminology, value, setValue, errors, validate, required }) => [
                              _createVNode(_unref(TerminologySearch), { terminology: terminology }, {
                                default: _withCtx(({ search, searching, results, error: terminologySearchError }) => [
                                  _createVNode(_unref(MedKitSearch), {
                                    class: _normalizeClass(_unref(getData)(props.path.add(`family_history.per_family_member.${familyMemberIndex}.deceased`)) === true ? 'col-span-12 md:col-span-6' : 'col-span-6 md:col-span-9'),
                                    "model-value": value ? { label: value['|value'], value: value } : undefined,
                                    error: terminologySearchError ?? errors[0],
                                    label: name,
                                    "label-hidden": display.mdAndUp ? clinicalHistoryVisualIndex > 0 : false,
                                    "is-loading": searching,
                                    options: results.map(result => ({
                            label: result['|value'],
                            value: result,
                          })),
                                    required: required,
                                    "onUpdate:query": search,
                                    "onUpdate:modelValue": ($event: any) => (setValue($event ? ($event as SearchOption).value : undefined)),
                                    onInput: validate
                                  }, null, 8, ["class", "model-value", "error", "label", "label-hidden", "is-loading", "options", "required", "onUpdate:query", "onUpdate:modelValue", "onInput"])
                                ]),
                                _: 2
                              }, 1032, ["terminology"])
                            ]),
                            _: 2
                          }, 1032, ["path"]),
                          _createVNode(_unref(DvDuration), {
                            path: props.path.add(`family_history.per_family_member.${familyMemberIndex}.clinical_history.${clinicalHistoryIndex}.age_at_onset`)
                          }, {
                            default: _withCtx(({
                        name,
                        duration,
                        period,
                        periodOptions,
                        setDuration,
                        setPeriod,
                        errors,
                        validateIfAlreadyValidated,
                        required
                      }) => [
                              _createVNode(_unref(MedKitNumberField), {
                                class: _normalizeClass(_unref(getData)(props.path.add(`family_history.per_family_member.${familyMemberIndex}.deceased`)) === true ? 'col-span-6 md:col-span-3' : 'col-span-6 md:col-span-3'),
                                error: errors[0],
                                label: name,
                                "label-hidden": display.mdAndUp ? clinicalHistoryVisualIndex > 0 : false,
                                "model-value": duration,
                                required: required,
                                "unit-options": periodOptions.map(option => ({
                          label: `${option.label}s`,
                          value: option.value,
                        })),
                                unit: period,
                                "onUpdate:modelValue": setDuration,
                                "onUpdate:unit": setPeriod,
                                onInput: validateIfAlreadyValidated
                              }, null, 8, ["class", "error", "label", "label-hidden", "model-value", "required", "unit-options", "unit", "onUpdate:modelValue", "onUpdate:unit", "onInput"])
                            ]),
                            _: 2
                          }, 1032, ["path"]),
                          _createVNode(_unref(DvCodedText), {
                            "present-if": _unref(getData)(props.path.add(`family_history.per_family_member.${familyMemberIndex}.deceased`)) === true,
                            path: props.path.add(`family_history.per_family_member.${familyMemberIndex}.clinical_history.${clinicalHistoryIndex}.cause_of_death`)
                          }, {
                            default: _withCtx(({ name, options, selected, setSelected, errors, validate, required }) => [
                              _createVNode(_unref(MedKitSelect), {
                                class: "col-span-6 md:col-span-3",
                                error: errors[0],
                                label: name,
                                "label-hidden": display.mdAndUp ? clinicalHistoryVisualIndex > 0 : false,
                                "model-value": selected,
                                options: options,
                                required: required,
                                "onUpdate:modelValue": setSelected,
                                onInput: validate
                              }, null, 8, ["error", "label", "label-hidden", "model-value", "options", "required", "onUpdate:modelValue", "onInput"])
                            ]),
                            _: 2
                          }, 1032, ["present-if", "path"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                          (count > 1)
                            ? (_openBlock(), _createBlock(_unref(MedKitButton), {
                                key: 0,
                                class: _normalizeClass(clinicalHistoryVisualIndex === 0 ? 'mt-8' : 'mt-8 md:mt-2'),
                                label: _unref(t)('familyHistory.clinicalHistory.remove'),
                                "icon-position": "only",
                                icon: "delete",
                                onClick: removeProblemDiagnosis
                              }, null, 8, ["class", "label", "onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["path"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["path", "present-if"])
    ]),
    _: 1
  }))
}
}

})